namespace Matrix.Workflow {

    interface ApprovalCommentDialogOptions {
        title: string;
        required: WorkflowCommentOption
    }

    @Serenity.Decorators.registerClass()
    export class ApprovalCommentDialog extends Serenity.PropertyDialog<any, ApprovalCommentDialogOptions> {

        private form: ApprovalCommentForm = new ApprovalCommentForm(this.idPrefix);

        constructor(opt: ApprovalCommentDialogOptions) {
            super();

            this.dialogTitle = opt.title;

            if (opt.required !== WorkflowCommentOption.Mandatory)
                Serenity.EditorUtils.setRequired(this.form.Comment, false);
        }

        public onSuccess: (comment: string) => void;

        protected okClickValidated() {
            var request = this.getSaveEntity() as { Comment: string };

            if (this.onSuccess) {
                this.onSuccess(request.Comment);
            }
        }

    }
}